<template>
  <a-modal
    title="用户列表"
    :width="800"
    v-model="visible"
  >
    <template slot="footer">
        <a-button key="back" type="primary" @click="handleCancel">
            关闭
        </a-button>
    </template>
    <a-table
      rowKey="userId"
      :columns="columns"
      :dataSource="userlist"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      bordered
    >
    </a-table>
  </a-modal>
</template>

<script>
import { getUserPage } from '@/baseAPI/user'
export default {
  name: 'ViewUserListModal',
  data () {
    return {
      visible: false,
      loading: false,
      // 查询参数
      queryParam: {
        roleId: ''
      },
      pagination: {},
      columns: [
        {
          title: '序号',
          dataIndex: 'serialnum'
        },
        {
          title: '登入名',
          dataIndex: 'userId'
        },
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '部门',
          dataIndex: 'orgName'
        },
        {
          title: '状态',
          dataIndex: 'enable',
          customRender: function (text) {
            return text? '启用' : '禁用'
          }
        },
        {
          title: '最后登入时间',
          dataIndex: 'lastLoginTime'

        }
      ],
      userlist: []
    }
  },
  mounted: function () {
  },
  methods: {
    show (id) {
      this.queryParam.roleId = id
      this.getUserPage()
      this.visible = true
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getUserPage()
    },
    getUserPage() {
      this.loading = true
      const params = Object.assign({ size: this.pagination.pageSize, current: this.pagination.current },this.queryParam)
      getUserPage(params).then(res => {
        const pagination = { ...this.pagination }
        pagination.total = res.data.total
        this.loading = false
        this.userlist = res.data.records
        this.userlist.forEach((item, index) => item.serialnum = (res.data.current - 1) * 10 + index + 1)
        this.pagination = pagination
      })
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>
